import styled from 'styled-components';

export enum EColors {
    PRIM1 = '#4B5597',
    PRIM2 = '#192261',
    ACC1_A = '#CDFFE6',
    ACC1_B = '#9DE4CC',
    ACC2_A = '#BC904F',
    ACC2_B = '#A43A18',
    WHITE = '#FFFFFF',
    DARK = '#141C54',
    DARK2 = '#51588d',
    GREY = '#7c7c7c',
    GREY1 = '#F5F5F5',
    GREY2 = '#EFEFEF',
    GREY3 = '#E7E7E7',
    GREY4 = '#A9A9A9',
    GREY5 = '#e0e0e0',
    GREY_EDITOR = '#C0C0C0',
    EDITOR_HIGHLIGHTED = '#CB9851',
    BLACK1 = '#414141',
    BLACK2 = '#191919',
    BLACK3 = '#1B1B1B',
    PRIM3 = '#212A69',
    ALMOST_BLACK = '#333333',
    ERROR_RED = '#FF9494',
    SELECT = '#E633AE'
}

export enum EGrads {
    PRIM_GRAD = `linear-gradient(180deg, #4B5597 0%, #192261 100%)`,
    ACC1_GRAD = `linear-gradient(270deg, #9DE4CC 0%, #CDFFE6 100%)`,
    ACC2_GRAD = 'linear-gradient(88.56deg, #BC904E 0%, #A33816 100%)',
    WHITE_GRAD = 'linear-gradient(180deg, #EEEEEE 0%, #FFFFFF 95.91%)',
    BLACK_GRAD = 'linear-gradient(180deg, #282727 0%, #1F1F1F 100%)'
}

export enum EShadows {
    INSIDE_SHADOW = 'inset 0px 0px 20px #1D1D1D',
    LIGHT = '0px 10px 20px rgba(0, 0, 0, 0.1)',
    STRONG = '0px 10px 30px rgba(0, 0, 0, 0.3)'
}

export enum EFonts {
    Medium = 'InterMedium',
    Bold = 'InterBold',
    Regular = 'InterRegular',
    Bold2 = 'InterBold',
    InterRegular = 'InterRegular',
    InterMedium = 'InterMedium',
    InterSemiBold = 'InterSemiBold',
    InterBold = 'InterBold'
}

export enum EHovers {
    LIGHT1 = 'inset 0 0 100px 100px rgba(255, 255, 255, 0.05)',
    LIGHT2 = 'inset 0 0 100px 100px rgba(255, 255, 255, 0.2)',
    LIGHT3 = 'inset 0 0 100px 100px rgba(255, 255, 255, 0.4)',
    LIGHT4 = 'inset 0 0 100px 100px rgba(255, 255, 255, 0.6)',
    DARK1 = 'inset 0 0 100px 100px rgba(0, 0, 0, 0.03)',
    DARK2 = 'inset 0 0 100px 100px rgba(0, 0, 0, 0.2)'
}

export enum EBorders {
    DARK = '#d3d3d3'
}

export const AnimTap = {
    whileHover: { scale: 1.05 },
    whileTap: { scale: 0.95 }
};

export const AnimTap2 = {
    whileHover: { scale: 1.2 },
    whileTap: { scale: 0.7 }
};

export const Reveal = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.2 }
};

export enum EVariables {
    Spacing = '-1.62px',
    Spacing2 = '-0.756px',
    Radius1 = '27px',
    Radius2 = '45px'
}

export enum EColors2 {
    DARK = '#041321',
    DARK2 = '#4A4A4A',
    GREY1 = '#F6F9FF',
    GREY2 = '#EAF0F5',
    LIGHT = '#FAFCFE',
    WHITE = '#FFFFFF'
}

export const S_IncreaseClick = styled.div`
    position: relative;
    &:before {
        position: absolute;
        content: '';
        top: -10px;
        right: -10px;
        left: -10px;
        bottom: -10px;
        cursor: pointer;
    }
`;
